import React, { useState, useMemo  } from 'react';
import { Download, X } from 'lucide-react';

function TicketDetails({ selectedTicket, files = [] }) {
  const [showFilesModal, setShowFilesModal] = useState(false);

  console.log('Selected Ticket Details:', selectedTicket);

  // Sample file data with more than 3 files
  const allFiles = [
    {
      id: 1,
      name: 'image.jpg',
      type: 'image',
      size: '2.3 MB',
      sharedDate: 'May 25th',
      agent: 'Agent Lisa'
    },
    {
      id: 2,
      name: 'doc.pdf',
      type: 'pdf',
      size: '1.8 MB',
      sharedDate: 'May 25th',
      agent: 'Agent Lisa'
    },
    {
      id: 3,
      name: 'error-numbering.jpg',
      type: 'image',
      size: '856 KB',
      sharedDate: 'May 25th',
      agent: 'Agent Lisa'
    },
    {
      id: 4,
      name: 'requirements.docx',
      type: 'document',
      size: '3.2 MB',
      sharedDate: 'May 24th',
      agent: 'Agent John'
    },
    {
      id: 5,
      name: 'screenshot.png',
      type: 'image',
      size: '1.1 MB',
      sharedDate: 'May 24th',
      agent: 'Agent Sarah'
    },
    {
      id: 6,
      name: 'report.xlsx',
      type: 'spreadsheet',
      size: '4.5 MB',
      sharedDate: 'May 23rd',
      agent: 'Agent Mike'
    }
  ];

 const visibleFiles = useMemo(() => files.slice(0, 3), [files]);
  const remainingFilesCount = Math.max(files.length - 3, 0);


  const handleDownload = (file) => {
    const link = document.createElement("a");
    link.href = file.url || "#";
    link.download = file.name || "download";
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    link.click();
  };

  const getFileIcon = (type) => {
    switch (type) {
      case "pdf":
        return <div className="pdf-icon">PDF</div>;
      case "document":
        return <div className="doc-icon">DOC</div>;
      case "spreadsheet":
        return <div className="excel-icon">XLS</div>;
      case "image":
      default:
        return <div className="file-icon">📄</div>;
    }
  };

  if (!selectedTicket) {
    return (
      <div className="ticket-details-container">
        <div className="no-ticket-details">
          <h3>Ticket Details</h3>
          <p>Select a ticket to view details</p>
        </div>
      </div>
    );
  }

  const TicketDetailsStyles = `
    .ticket-details-container {
      height: 100%;
      display: flex;
      flex-direction: column;
      background: white;
      border-left: 1px solid #e5e5e5;
      overflow: hidden;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
    }

    .no-ticket-details {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
      color: #6b7280;
      padding: 24px;
    }

    .no-ticket-details h3 {
      margin-bottom: 8px;
      color: #374151;
      font-weight: 500;
    }

    .ticket-details-header {
      padding: 14px;
      background-color: white;
      border-bottom: 1px solid #e5e5e5;
      flex-shrink: 0;
    }

    .dropdown-btn {
      width: 100%;
      padding: 10px 12px;
      border-radius: 6px;
      background: white;
      font-size: 16px;
      font-weight: 600;
      color: #374151;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: space-between;
      text-align: left;
      transition: border-color 0.15s ease;
    }

    .dropdown-btn:hover {
      border-color: #9ca3af;
    }

    .dropdown-arrow {
      font-size: 12px;
      color: #6b7280;
    }

    .ticket-details-content {
      flex: 1;
      overflow-y: auto;
      overflow-x: hidden;
      padding: 0;
      height: 0;
    }

    .ticket-details-content {
      -ms-overflow-style: none;
      scrollbar-width: none;
    }

    .ticket-details-content::-webkit-scrollbar {
      display: none;
    }

    .content-section {
      padding: 20px 16px;
    }

    .section-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .section-title {
      font-size: 16px;
      font-weight: 600;
      color: #1f2937;
      margin: 0;
    }

    .subsection-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;
      padding-bottom: 8px;
    }

    .subsection-title {
      font-size: 14px;
      font-weight: 500;
      color: #374151;
      margin: 0;
    }

    .edit-btn {
      color: #2563eb;
      font-size: 14px;
      font-weight: 500;
      background: none;
      border: none;
      cursor: pointer;
      padding: 0;
    }

    .edit-btn:hover {
      text-decoration: underline;
    }

    .info-list {
      display: flex;
      flex-direction: column;
      gap: 0;
    }

    .info-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 0;
      border-bottom: 1px solid #f3f4f6;
      font-size: 14px;
    }

    .info-item:last-child {
      border-bottom: none;
    }

    .info-label {
      color: #6b7280;
      font-weight: 400;
      flex: 1;
    }

    .info-value {
      color: #1f2937;
      font-weight: 500;
      text-align: right;
    }

    .info-value.link {
      color: #277722;
      cursor: pointer;
      text-decoration: none;
    }

    .info-value.link:hover {
      text-decoration: underline;
    }

    .view-map-link {
      color: #277722;
      font-size: 14px;
      font-weight: 400;
      text-decoration: none;
      margin-left: 4px;
    }

    .view-map-link:hover {
      text-decoration: underline;
    }

    .ip-value {
      font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
      font-size: 13px;
      font-weight: 500;
    }

    .files-section {
      margin-top: 24px;
      border-top: 1px solid #e5e5e5;
    }

    .files-card {
      background: #f8f9fa;
      border-radius: 8px;
      margin-top: 16px;
    }

    .files-title {
      font-size: 14px;
      font-weight: 600;
      color: #1f2937;
      margin: 0 0 12px 0;
    }

    .file-list {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    .file-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 8px;
      background: white;
      border-radius: 6px;
      border: 1px solid #e5e5e5;
      transition: all 0.15s ease;
    }

    .file-item:hover {
      border-color: #d1d5db;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    }

    .file-item-left {
      display: flex;
      align-items: center;
      gap: 10px;
      flex: 1;
      min-width: 0;
    }

    .file-icon {
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      font-size: 12px;
    }

    .pdf-icon {
      width: 20px;
      height: 20px;
      background: #dc2626;
      color: white;
      font-size: 8px;
      font-weight: bold;
      border-radius: 2px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .doc-icon {
      width: 20px;
      height: 20px;
      background: #2563eb;
      color: white;
      font-size: 7px;
      font-weight: bold;
      border-radius: 2px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .excel-icon {
      width: 20px;
      height: 20px;
      background: #16a34a;
      color: white;
      font-size: 7px;
      font-weight: bold;
      border-radius: 2px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .file-info {
      flex: 1;
      min-width: 0;
    }

    .file-name {
      color: #1f2937;
      font-weight: 500;
      font-size: 13px;
      margin: 0 0 2px 0;
      word-break: break-word;
    }

    .file-meta {
      color: #6b7280;
      font-size: 11px;
      margin: 0;
      word-break: break-word;
    }

    .download-btn {
      padding: 4px;
      background: none;
      border: none;
      cursor: pointer;
      border-radius: 4px;
      color: #6b7280;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.15s ease;
    }

    .download-btn:hover {
      background-color: #f3f4f6;
      color: #374151;
    }

    .show-more-btn {
      color: #2563eb;
      background: none;
      border: none;
      cursor: pointer;
      padding: 8px 0 0 0;
      font-size: 13px;
      font-weight: 500;
      text-align: left;
      width: auto;
    }

    .show-more-btn:hover {
      text-decoration: underline;
    }

    .section-divider {
      margin: 24px 0;
      border-top: 1px solid #f3f4f6;
    }

    /* Modal Styles */
    .modal-overlay {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1000;
    }

    .modal-content {
      background: white;
      border-radius: 12px;
      padding: 24px;
      max-width: 500px;
      width: 90%;
      max-height: 80vh;
      overflow-y: auto;
      box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
    }

    .modal-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
      padding-bottom: 12px;
      border-bottom: 1px solid #e5e5e5;
    }

    .modal-title {
      font-size: 18px;
      font-weight: 600;
      color: #1f2937;
      margin: 0;
    }

    .close-btn {
      background: none;
      border: none;
      cursor: pointer;
      padding: 4px;
      border-radius: 4px;
      color: #6b7280;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .close-btn:hover {
      background-color: #f3f4f6;
      color: #374151;
    }

    .modal-file-list {
      display: flex;
      flex-direction: column;
      gap: 12px;
    }

    .modal-file-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 12px;
      background: #f8f9fa;
      border-radius: 8px;
      border: 1px solid #e5e5e5;
      transition: all 0.15s ease;
    }

    .modal-file-item:hover {
      border-color: #d1d5db;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    }
  `;

  return (
    <>
      <style>{TicketDetailsStyles}</style>
      <div className="ticket-details-container">
        <div className="ticket-details-header">
          <button className="dropdown-btn">
            TICKET DETAILS
            <span className="dropdown-arrow">▼</span>
          </button>
        </div>

        <div className="ticket-details-content">
          <div className="content-section">
            {/* Visitor Information Section */}
            <div className="section-header">
              <h3 className="section-title">Visitor Information</h3>
            </div>

            {/* Basic Details Subsection */}
            <div className="subsection-header">
              <h4 className="subsection-title">Basic Details</h4>
              {/* <button className="edit-btn">Edit</button> */}
            </div>

          <div className="info-list">
  <div className="info-item">
    <span className="info-label">Clinic Name</span>
    <span className="info-value">{selectedTicket?.clinicName || "N/A"}</span>
  </div>

  <div className="info-item">
    <span className="info-label">Email</span>
    <span className="info-value link">
      {selectedTicket?.email || "N/A"}
    </span>
  </div>

  <div className="info-item">
    <span className="info-label">Phone</span>
    <span className="info-value">
      {selectedTicket?.primaryPhoneNumber || "N/A"}
    </span>
  </div>

  <div className="info-item">
    <span className="info-label">Address</span>
    <span className="info-value">
      {[selectedTicket?.addressLine1, selectedTicket?.addressLine2, selectedTicket?.city, selectedTicket?.state, selectedTicket?.postal_ZIPCode, selectedTicket?.country]
        .filter(Boolean)
        .join(", ")}
    </span>
  </div>

  <div className="info-item">
    <span className="info-label">Facility Type</span>
    <span className="info-value">
      {selectedTicket?.typeofFacility || "N/A"}
    </span>
  </div>

  <div className="info-item">
    <span className="info-label">Created At</span>
    <span className="info-value">
      {new Date(selectedTicket?.createdAt).toLocaleString()}
    </span>
  </div>

  <div className="info-item">
    <span className="info-label">Status</span>
    <span
      className="info-value"
      style={{
        color:
          selectedTicket?.status === "Resolved" ? "#16a34a" : "#d97706",
        fontWeight: 600,
      }}
    >
      {selectedTicket?.status}
    </span>
  </div>
</div>


            <div className="section-divider"></div>

            {/* Device Info Subsection */}
            <div className="subsection-header">
              <h4 className="subsection-title">Device Info</h4>
              {/* <button className="edit-btn">Edit</button> */}
            </div>

            <div className="info-list">
              <div className="info-item">
                <span className="info-label">IP</span>
                <span className="info-value ip-value">107.116.91.201</span>
              </div>

              <div className="info-item">
                <span className="info-label">OS</span>
                <span className="info-value">Windows 10</span>
              </div>

              <div className="info-item">
                <span className="info-label">Browser</span>
                <span className="info-value">Mozilla Firefox</span>
              </div>
            </div>

            {/* Files Shared Section */}
         <div className="files-section">
              <div className="files-card">
                <h4 className="files-title">Files Shared</h4>

                <div className="file-list">
                  {visibleFiles.map((file) => (
                    <div key={file.id} className="file-item">
                      <div className="file-item-left">
                        {getFileIcon(file.type)}
                        <div className="file-info">
                          <div className="file-name">{file.name}</div>
                          <div className="file-meta">
                            {`Shared by ${file.agent} on ${file.sharedDate}${file.size ? ` • ${file.size}` : ""}`}
                          </div>
                        </div>
                      </div>
                      <button
                        className="download-btn"
                        onClick={() => handleDownload(file)}
                        title="Download file"
                      >
                        <Download size={16} />
                      </button>
                    </div>
                  ))}
                </div>

                {remainingFilesCount > 0 && (
                  <button
                    className="show-more-btn"
                    onClick={() => setShowFilesModal(true)}
                  >
                    Show More
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>

        {showFilesModal && (
          <div className="modal-overlay" onClick={() => setShowFilesModal(false)}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h3 className="modal-title">All Shared Files ({files.length})</h3>
                <button
                  className="close-btn"
                  onClick={() => setShowFilesModal(false)}
                >
                  <X size={20} />
                </button>
              </div>

              <div className="modal-file-list">
                {files.map((file) => (
                  <div key={file.id} className="modal-file-item">
                    <div className="file-item-left">
                      {getFileIcon(file.type)}
                      <div className="file-info">
                        <div className="file-name">{file.name}</div>
                        <div className="file-meta">
                          {`Shared by ${file.agent} on ${file.sharedDate}${file.size ? ` • ${file.size}` : ""}`}
                        </div>
                      </div>
                    </div>
                    <button
                      className="download-btn"
                      onClick={() => handleDownload(file)}
                      title="Download file"
                    >
                      <Download size={16} />
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default TicketDetails;
